import React, { useState } from 'react';
import { TIMELINE, AGENCIES } from '../mock';
import { Star } from 'lucide-react';

export default function TimelinePage() {
  const [decade, setDecade] = useState('ALL');
  const decades = Array.from(new Set(TIMELINE.map(t => Math.floor(t.year/10)*10))).sort();
  const filtered = decade === 'ALL' ? TIMELINE : TIMELINE.filter(t => Math.floor(t.year/10)*10 === decade);

  const grouped = filtered.reduce((acc, t) => {
    if (!acc[t.year]) acc[t.year] = [];
    acc[t.year].push(t);
    return acc;
  }, {});
  const years = Object.keys(grouped).map(Number).sort((a,b) => a-b);

  return (
    <div>
      <div className="relative border-b border-white/5">
        <div className="absolute inset-0 stars-bg twinkle" />
        <div className="absolute inset-0 bg-grid opacity-30" />
        <div className="relative mx-auto max-w-[1300px] px-6 py-8">
          <div className="mono text-[10px] tracking-[0.2em] text-amber-300/90 uppercase mb-2">Chronologie 1947 — 2026</div>
          <h1 className="serif text-3xl md:text-4xl">80 ans de <span className="italic text-amber-300">phénomènes</span> non identifiés</h1>
          <p className="text-2 mt-2 max-w-3xl text-sm">{TIMELINE.length} dates clés, de Kenneth Arnold (1947) à la directive Trump et PURSUE Release 01.</p>

          <div className="mt-4 flex flex-wrap gap-1.5">
            <button onClick={()=>setDecade('ALL')} className={`mono text-[10px] px-2 py-0.5 rounded border ${decade==='ALL' ? 'bg-amber-400/15 border-amber-300/40 text-amber-100' : 'border-white/10 text-2 hover:bg-white/5'}`}>Toutes</button>
            {decades.map(d => (
              <button key={d} onClick={()=>setDecade(d)} className={`mono text-[10px] px-2 py-0.5 rounded border ${decade===d ? 'bg-amber-400/15 border-amber-300/40 text-amber-100' : 'border-white/10 text-2 hover:bg-white/5'}`}>{d}s</button>
            ))}
          </div>
        </div>
      </div>

      <div className="mx-auto max-w-[1200px] px-6 py-8">
        <div className="relative">
          <div className="absolute left-[88px] md:left-[120px] top-0 bottom-0 w-px bg-gradient-to-b from-transparent via-amber-300/30 to-transparent" />

          {years.map((year) => (
            <div key={year} className="relative mb-6">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-[88px] md:w-[120px] flex-shrink-0 flex justify-end pr-4">
                  <div className="serif text-3xl md:text-4xl font-medium text-amber-300 leading-none">{year}</div>
                </div>
                <div className="h-px flex-1 bg-amber-300/30" />
              </div>

              {grouped[year].map((t, idx) => {
                const a = AGENCIES.find(x => x.id === t.agency);
                const color = a?.color || '#a78bfa';
                return (
                  <div key={idx} className="relative flex items-stretch mb-2.5">
                    <div className="w-[88px] md:w-[120px] flex-shrink-0 flex flex-col items-end pr-4 pt-2">
                      <div className="mono text-[10px] text-1 tracking-wider whitespace-nowrap text-right">{t.date}</div>
                      <div className="mt-1 mono text-[9px] px-1.5 py-px rounded border" style={{ borderColor: `${color}55`, color }}>
                        {t.agency}
                      </div>
                    </div>

                    <div className="relative flex flex-col items-center" style={{ width: '0' }}>
                      <div className={`absolute -left-2 top-2.5 h-4 w-4 rounded-full flex items-center justify-center z-10 ${t.highlight ? 'animate-pulse' : ''}`}
                          style={{ background: color, boxShadow: `0 0 0 3px ${color}1a, 0 0 12px ${color}66` }}>
                        {t.highlight && <Star className="h-2 w-2 text-black" fill="currentColor" />}
                      </div>
                    </div>

                    <div className="flex-1 ml-5">
                      <div className="glass rounded-md p-3 doc-card border-l-2" style={{ borderLeftColor: color }}>
                        <div className="flex items-start justify-between gap-3 mb-1">
                          <div className="text-1 text-base serif font-medium">{t.title}</div>
                          {t.highlight && <span className="mono text-[9px] px-1.5 py-px rounded bg-amber-300/15 text-amber-200 border border-amber-300/30 shrink-0">Majeur</span>}
                        </div>
                        <p className="text-2 text-sm leading-relaxed">{t.desc}</p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
